import React from 'react';
import Styles from './styles.js';
import HeadingSection from 'components/LandingPageHeadingSection/HeadingSection';

const PropertyViewer = ({ children, title, bg }) => {
  return (
    <>
      {bg == 'black' ? (
        <div className="pt-3 pb-16" style={{ backgroundColor: '#171717' }}>
          <HeadingSection title={title} bgcolor="black" />
          <div className="container px-6 lg:px-0 mx-auto">
            <div>
              <div className="row justify-center">
                <div className="col-md-12 ">
                  <div className="matterport-showcase">{children}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div>
          <HeadingSection title={title} bgcolor="white" />
          <div className="container mx-auto">
            <div>
              <div className="row justify-center">
                <div className="col-md-12">
                  <div className="matterport-showcase">{children}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <Styles/>
    </>
  );
};

export default PropertyViewer;
